export const toolProps = {
  height: Number,
  size: {
    type: String,
    default() {
      return "default";
    },
  },
  prominent: Boolean,
  extensionHeight: {
    type: String,
    default() {
      return "24";
    },
  },
  floating: Boolean,
};

export const toolAppProps = {
  ...toolProps,
  title: String,
  type: {
    type: String,
    default() {
      return "main";
    },
    validator(value) {
      return ["main", "sub", "dialog"].indexOf(value) > -1;
    },
  },
};
